import { useContext } from 'react'
import { StoreContextType } from '@/context/types'
import { MESSAGE_TYPES } from '@/context/constants'

const Errors = (context: React.Context<StoreContextType | null>) => {
  const store = useContext(context) as StoreContextType

  const getErrors = () => store.errors.errors

  const setErrors = (type: string, errors: any) => {
    store.errors.setErrors(errors)
    if (type === MESSAGE_TYPES.INIT) {
      store.init.setIsInit(false)
    }
  }

  const clearErrors = () => store.errors.setErrors([])

  return { getErrors, setErrors, clearErrors }
}

export default Errors
